var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('bc-cidr-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }